import { render, staticRenderFns } from "./remindrule.vue?vue&type=template&id=1928176c&scoped=true&"
import script from "./remindrule.vue?vue&type=script&lang=js&"
export * from "./remindrule.vue?vue&type=script&lang=js&"
import style0 from "./remindrule.vue?vue&type=style&index=0&id=1928176c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1928176c",
  null
  
)

export default component.exports